import React from 'react';
import { initReactApp } from 'shared/util/ApplicationInit';
import ProductDetails from './ProductDetails';

const render = initReactApp(() => <ProductDetails />, 'product-details');

render();

// optional, use this to enable hot reloading
if ((module as any).hot) {
	(module as any).hot.accept('./ProductDetails', () => {
		render();
	});
}
